export default __webpack_public_path__ + "static/media/animatelogo.670bcde6.gif";